<template>
    <div class="flex flex-wrap" :class="classes">
        <div class="mr-1 mb-1"
             v-for="value in values"
             :key="value.key">
            <label :ref="`label-${item.code}-${value.key}`"
                   :class="[model === value.value ? 'bg-primary text-white' : 'bg-gray-200', xPerSelection ? 'px-3 2xl:px-4' : 'px-4']"
                   class="flex items-center rounded-full py-2 cursor-pointer leading-none capitalize">
                <input
                    type="radio"
                    :name="item.code"
                    :value="value.value"
                    v-model="model"
                    class="hidden"
                />
                <icon-check :class="{'mr-1': model === value.value}"
                            v-if="withCheckIcon"
                            :h="model === value.value ? 14 : 0"
                            :w="model === value.value ? 17 : 0"/>
                {{ value.title.toLowerCase() }}
            </label>
        </div>
    </div>
</template>

<script>
    import { EventBus } from "@widget/plugins/event-bus";

    export default {
        name: "radio-list",
        props: {
            item: {
                type: Object,
                require: true,
                default: () => {
                    return {};
                }
            },
            classes: {
                type: String,
                default: ""
            },
            withCheckIcon: {
                type: Boolean,
                default: true
            },
            xPerSelection: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            values () {
                return this.item.values;
            },
            model: {
                set (value) {
                    if (!value) return;

                    let title = `${this.item.title}: ${value.charAt(0).toUpperCase() + value.toLowerCase().slice(1)}`;
                    if (this.xPerSelection) {
                        let valueObj = this.item.values.find(item => item.value === value);
                        title = `${this.item.title.replace("Number of c", "C")}: ${valueObj.title}`;
                    }
                    this.$store.commit("widgetData/addSelect", {
                        sensitive: this.item.attentionText !== "",
                        code: this.item.code,
                        group: this.item.group,
                        title,
                        query: value
                    });
                },
                get () {
                    let modelStore = this.$store.getters["widgetData/getSelectByCode"](this.item.code);
                    if (modelStore) {
                        this.$emit("open");
                        return modelStore.query;
                    }
                    return [];
                }
            }
        },
        mounted () {
            EventBus.$on("remove-select", code => {
                if (code === this.item.code) {
                    this.model = null;

                    this.$emit("close");
                }
            });

            EventBus.$on("clear-all", () => {
                this.model = null;

                this.$emit("close");
            });
        }
    };
</script>
